<template>
  <div>
    <div class="usrBox">
      <van-divider content-position="left">预警</van-divider>
      <van-grid class="shebei" :border="false" :column-num="2">
        <van-grid-item to="SimList/1">
          <div class="header1 leftBtn">
            <div class="sbDiv">
              <p>套餐临期(7天)</p>
              <span>{{this.adventEqp}}</span>
            </div>
          </div>
        </van-grid-item>
        <van-grid-item to="SimList/2">
          <div class="header1 rightBtn">
            <div class="sbDiv ssd">
              <p>流量不足(5M)</p>
              <span>{{this.lackEqp}}</span>
            </div>
          </div>
        </van-grid-item>
      </van-grid>
      <van-divider content-position="left">已停机</van-divider>
      <van-grid class="shebei" :border="false" :column-num="3">
        <van-grid-item to="SimList/3">
          <div class="header1 leftBtn2">
            <div class="sbDiv">
              <p>流量超额</p>
              <span>{{this.overFlowEqp}}</span>
            </div>
          </div>
        </van-grid-item>
        <van-grid-item to="SimList/4">
          <div class="header1 rightBtn2">
            <div class="sbDiv ssd">
              <p>机卡分离</p>
              <span>{{this.offEqp}}</span>
            </div>
          </div>
        </van-grid-item>
        <van-grid-item to="SimList/5">
          <div class="header1 rightBtn2">
            <div class="sbDiv ssd">
              <p>静默停机</p>
              <span>{{this.silenceEqp}}</span>
            </div>
          </div>
        </van-grid-item>
      </van-grid>
      <van-divider content-position="left">快捷功能</van-divider>
      <van-grid :border="false" :column-num="3">
        <div class="box" v-for="(item, index) in list" :key="index">
          <van-grid-item :to="item.push" :text="item.text" :class="'van-grid-item-tips_'+index">
            <template slot="icon">
              <span :class="item.icon"></span>
            </template>
          </van-grid-item>
        </div>
      </van-grid>
      <div class="footer">
        <!-- <p>侵权必究 2021</p> -->
        <br />
        <br />
        <p @click="showDriver">操作指引</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SimStat
} from '@/api/Equipment.js'
// 引导组件
import Driver from 'driver.js'
import 'driver.js/dist/driver.min.css'
export default {
  components: {},
  props: {},
  data () {
    // van-icon van-icon-vip-card-o
    return {
      list: [{
        text: '我的分润',
        icon: 'iconfont icon-jiagebiao- yellow',
        push: 'Balance'
      },
      {
        text: '流量订单',
        icon: 'iconfont icon-chaxun blue',
        push: 'Order'
      },
      {
        text: '预存账户',
        icon: 'iconfont icon-yue deepBlue',
        push: 'BalancePre'
      },
      {
        text: '分享',
        icon: 'iconfont icon-lianjie greend',
        push: 'QRcode'
      },
      {
        text: '拓展代理',
        icon: 'iconfont icon-dailishang agentManagement',
        push: 'AgentManagement'
      },
      {
        text: '我的售价', // todo
        icon: 'iconfont icon-xiugai pinkRed',
        push: 'PackageConfig'
      }
      ],
      adventEqp: '',
      lackEqp: '',
      offEqp: '',
      silenceEqp: '',
      overFlowEqp: '',
      topUsername: '',
      rank: '',
      ranks: '',
      // 等级进度
      percentageNum: 70
    }
  },
  watch: {},
  computed: {},
  methods: {
    // 超流量数量,已停机数量
    async mobileIndex () {
      const {
        data: res
      } = await SimStat({
        token: this.$store.state.token,
        userId: this.$store.state.userID?.split('a')[0]
      })
      this.adventEqp = res.adventEqp ? res.adventEqp : 0
      this.lackEqp = res.lackEqp ? res.lackEqp : 0
      this.offEqp = res.offEqp ? res.offEqp : 0
      this.overFlowEqp = res.overFlowEqp ? res.overFlowEqp : 0
      this.silenceEqp = res.silenceEqp ? res.silenceEqp : 0

      this.$store.commit('setAdventEqp', res.adventEqp)
      this.$store.commit('setLackEqp', res.lackEqp)
      this.$store.commit('setOffEqp', res.offEqp)
      this.$store.commit('setOverFlowEqp', res.overFlowEqp)
      this.$store.commit('setSilenceEqp', res.silenceEqp)
    },
    showDriver (forceShow = true) {
      if (!this.$store.state.token) {
        return
      }
      const driver = new Driver({
        allowClose: false,
        overlayClickNext: true,
        keyboardControl: true,
        closeBtnText: '跳过',
        doneBtnText: '我知道了',
        opacity: 0.75,
        padding: 10,
        nextBtnText: '下一步',
        prevBtnText: '上一步',

        buttons: {
          isFirst: {
            text: '下一步',
            className: 'driver-btn-next'
          },
          isLast: {
            text: '我知道了',
            className: 'driver-btn-done'
          }
        }
      })
      driver.defineSteps([
        {
          element: '.van-grid-item-tips_0',
          popover: {
            title: '查看分润与提现',
            description: '您的收益明细和提现入口都在这里。<br />💡 想扩大分润范围？可拓展下级代理 <br />💡 想调整单卡收益？可设置专属售价',
            position: 'bottom'
          }
        },
        {
          element: '.van-grid-item-tips_2',
          popover: {
            title: '预存钱包',
            description: '预存享专属折扣，充值SIM卡时还可叠加抵扣优惠',
            position: 'bottom'
          }
        },
        {
          element: '.tipsSIM',
          popover: {
            title: 'SIM卡管理中心',
            description: '充值、划拨、查状态等日常操作，点这里快速办理',
            position: 'top'
          },
          onHighlighted: (step) => {
            const stage = document.getElementById('driver-highlighted-element-stage')
            if (stage) {
              stage.style.backgroundColor = 'transparent'
              stage.style.border = '1px solid rgba(85, 170, 255, 0.8)'
              stage.style.boxShadow = '0 0 0 2px rgba(85, 170, 255, 0.5)'
            }
          }
        }
      ])
      // 首次访问时触发
      if (!localStorage.getItem('guide_shown') || forceShow) {
        driver.start()
        localStorage.setItem('guide_shown', 'true')
      }
    }
  },
  beforeCreate () {
    if (!this.$store.state.token) {
      this.$router.push('/login/no')
      this.$toast.fail('请重新登录')
    }
  },
  created () {
    this.lackEqp = this.$store.state.lackEqp
    this.adventEqp = this.$store.state.adventEqp
    this.offEqp = this.$store.state.offEqp
    this.overFlowEqp = this.$store.state.overFlowEqp
    this.silenceEqp = this.$store.state.silenceEqp
    const agentName = this.$store.state.agentName
    this.topUsername = (agentName && agentName !== 'undefined') ? this.$store.state.agentName : this.$store.state
      .userName
    this.mobileIndex()
  },
  mounted () {
    this.showDriver(false)
  }
}
</script>

<style scoped lang='less'>
  .usrBox {
    padding: 5px 25px 0;
    height: 100%;
    padding-bottom: 100px;
    box-sizing: border-box;

    .header {
      height: 326px;
      width: 100%;
      border-radius: 15px;
      background-color: red;
      background: url(../../../assets/home-banner.png) no-repeat center;
      background-size: 100% 385px;
      overflow: hidden;
      padding-top: 30px;
      color: #fff;

      .info {
        font-size: 36px;
      }

      .degree {
        padding-top: 25px;
        font-size: 30px;

        /deep/.van-progress__pivot {
          display: none;
        }
      }

      .item {
        padding-top: 40px;
        text-align: center;
        font-size: 26px;
      }
    }

    .box {
      width: 29%;
      height: 185px;
      background-color: #fff;
      margin: 12px 2%;
      box-shadow: 0 4px 10px 5px rgba(15, 27, 115, 8%);
      border-radius: 15px;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 8px;
      font-weight: 400;

      .van-grid-item {
        flex: 1;
        padding-right: 0 !important;
        height: 80%;
      }

      /deep/.van-grid-item__content {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding: 15px;
      }
    }

    .shebei {
      /deep/.van-grid-item__content {
        padding: 3px 8px;

        .header1 {
          height: 142px;
          width: 100%;
          border-radius: 15px;
          color: #fff;

          .sbDiv {
            display: flex;
            height: 100%;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            padding: 24px 0 0;

            p {
              font-size: 32px;
            }

            span {
              font-size: 36px;
            }
          }
        }

        .leftBtn {
          background: url(../../../assets/Stream-2.png) no-repeat center;
          background-size: cover;
        }

        .rightBtn {
          background: url(../../../assets/Stream-1.png) no-repeat center;
          background-size: cover;
        }

        .leftBtn2 {
          background: url(../../../assets/Stream-4.png) no-repeat center;
          background-size: cover;
        }

        .rightBtn2 {
          background: url(../../../assets/Stream-3.png) no-repeat center;
          background-size: cover;
        }
      }
    }

    .van-cell-group {
      margin-top: 15px;
      overflow-y: scroll;
      height: 1100px;

      .van-cell:last-child {
        color: #AFAFB8;
        text-align: center;
      }
    }

    /deep/.van-divider {
      margin: 18px 0;
      font-size: 24px !important;
      color: rgba(51, 51, 51, 0.6);
    }

    .van-divider--content-left::before {
      max-width: 0%;
      margin: 0;
    }
  }

  [class*=van-hairline]::after {
    border: none;
  }

  .greend {
    color: #388E3C;
  }

  .blue {
    color: #1296db;
  }

  .deepBlue {
    color: #13227a;
  }

  .pinkRed {
    color: #ff9383;
  }

  .yellow {
    color: #ffa347;
  }

  .agentManagement {
    color: #7B1FA2;
  }

  .box span {
    font-size: 68px;
    margin-bottom: 10px;
  }

  .samles {
    font-size: 50px !important;
  }

  .footer {
    width: 100%;
    text-align: center;

    p {
      font-size: 25px;
      color: #bbbbbb;
    }

    margin: 5px 0 15px;
  }
</style>
